
const onlyNumbers = (str = '') => {
  return str.replace(/\D/g, "");
}

const updateNumberWithDots = (val) => {
  const newVal = val.split('').reverse().map((item, index) => {
      if (
          (index % 3 === 0 && index !== 0) ||
          (index === 3 && val.length !== 3)
      ) {
          return `${item}.`
      }

      return item
  })

  return newVal.reverse().join('')
}

const maskWithCommasAndDots = (val, cases = 4) => {
  const hasComma = val.includes(',')
  const zeroAfterComma = new Array(cases).fill('0').join("") 
  
  if (hasComma) {
      const valSplit = val.split(',')
      const afterComma = onlyNumbers(valSplit[1])
      const afterCommaSplit = `${afterComma}${zeroAfterComma}`
      return `${updateNumberWithDots(onlyNumbers(valSplit[0])) || 0},${afterCommaSplit.substring(0, cases)}`
  }

  return `${updateNumberWithDots(onlyNumbers(val)) || 0},${zeroAfterComma}`
}

export default maskWithCommasAndDots